module.exports = __webpack_public_path__ + "img/girl1.716b8a71.jpg";